$(document).ready(function() {

    $('.productslider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
         dots: true,
        arrows: false, 
        autoplaySpeed: 3000,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


    $('.reviewslider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


    $('.instaslider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });











});

jQuery(document).ready(function($) {
    $('.slick.marquee').slick({
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
    });
});




// jQuery(document).ready(function($) {
//     $('.slick1.marquee_rtl').slick({
//       speed: 5000,
//       autoplay: true,
//       autoplaySpeed: 0,
//       centerMode: true,
//       cssEase: 'linear',
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       variableWidth: true,
//       infinite: true,
//       initialSlide: 1,
//       arrows: false,
//       rtl:true,
//       buttons: false

//     });
//   });



// cursor script

const cursor = document.querySelector('.cursor');

document.addEventListener('mousemove', e => {
    cursor.setAttribute("style", "top: " + (e.pageY - 10) + "px; left: " + (e.pageX - 10) + "px;")
})

document.addEventListener('click', () => {
    cursor.classList.add("expand");

    setTimeout(() => {
        cursor.classList.remove("expand");
    }, 500)
})

// end



// marquee start


function handleMarquee() {
    const marquee = document.querySelectorAll('.marquee');
    let speed = 1;
    let lastScrollPos = 0;
    let timer;

    marquee.forEach(function(el) {
        // stop animation on mouseenter
        mouseEntered = false;
        document.querySelector('.inner').addEventListener('mouseenter', function() {
            mouseEntered = true;
        })
        document.querySelector('.inner').addEventListener('mouseleave', function() {
            mouseEntered = false
        })

        const container = el.querySelector('.inner');
        const content = el.querySelector('.inner > *');
        //Get total width
        const elWidth = content.offsetWidth;

        //Duplicate content
        let clone = content.cloneNode(true);
        container.appendChild(clone);

        let progress = 1;

        function loop() {
            if (mouseEntered === false) { progress = progress - speed; }
            if (progress <= elWidth * -1) { progress = 0; }
            container.style.transform = 'translateX(' + progress + 'px)';
            window.requestAnimationFrame(loop);
        }
        loop();
    });

    function handleSpeedClear() {
        speed = 50;
    }
};

handleMarquee();


// end




function handleMarquee1() {
    const marquee = document.querySelectorAll('.marquee2');
    let speed = 1;
    let mouseEntered = false;

    marquee.forEach(function(el) {
        const container = el.querySelector('.inner2');
        const content = el.querySelector('.inner2 > *');

        // Get total width
        const elWidth = content.offsetWidth;

        // Duplicate content for seamless loop
        let clone = content.cloneNode(true);
        container.appendChild(clone);

        let progress = -elWidth; // start off-screen (left)

        // Hover pause
        container.addEventListener('mouseenter', () => mouseEntered = true);
        container.addEventListener('mouseleave', () => mouseEntered = false);

        function loop() {
            if (!mouseEntered) { progress = progress + speed; } // ðŸ‘ˆ ADD instead of SUBTRACT
            if (progress >= 0) { progress = -elWidth; } // reset when finished
            container.style.transform = 'translateX(' + progress + 'px)';
            window.requestAnimationFrame(loop);
        }
        loop();
    });
}
handleMarquee1();

// end


// Contdown

